import * as allocationBatch from "./allocationBatch";
import * as allocationBatchFacadeImpl from "./allocationBatchFacadeImpl";
import * as allocationBox from "./allocationBox";
import * as allocationContainer from "./allocationContainer";
import * as allocationFacadeImpl from "./allocationFacadeImpl";
import * as allocationMaster from "./allocationMaster";
import * as allocationMasterFacadeImpl from "./allocationMasterFacadeImpl";
import * as allocationPlan from "./allocationPlan";
import * as allolcationTrial from "./allolcationTrial";
import * as approvalFacade from "./approvalFacade";
import * as approvalFacadeImpl from "./approvalFacadeImpl";
import * as changeOrder from "./changeOrder";
import * as changeOrderDetail from "./changeOrderDetail";
import * as common from "./common";
import * as defaultShopInfo from "./defaultShopInfo";
import * as demandOrder from "./demandOrder";
import * as demandPlanFacadeImpl from "./demandPlanFacadeImpl";
import * as finalTrialOrder from "./finalTrialOrder";
import * as finalTrialOrderDetail from "./finalTrialOrderDetail";
import * as financeVoucherReport from "./financeVoucherReport";
import * as firstTrialOrder from "./firstTrialOrder";
import * as firstTrialOrderDetail from "./firstTrialOrderDetail";
import * as frozenCreateOrder from "./frozenCreateOrder";
import * as frozenState from "./frozenState";
import * as inDetail from "./inDetail";
import * as inDetailBox from "./inDetailBox";
import * as inDetailRecord from "./inDetailRecord";
import * as inMaster from "./inMaster";
import * as inMasterFacadeImpl from "./inMasterFacadeImpl";
import * as inPlateMaster from "./inPlateMaster";
import * as inoutStepRecord from "./inoutStepRecord";
import * as inventoryMaster from "./inventoryMaster";
import * as lendMaster from "./lendMaster";
import * as logisticsCycleInfo from "./logisticsCycleInfo";
import * as logisticsReturnRecord from "./logisticsReturnRecord";
import * as logisticsReverseFacadeImpl from "./logisticsReverseFacadeImpl";
import * as logisticsWaybillLabel from "./logisticsWaybillLabel";
import * as nsStorage from "./nsStorage";
import * as operateForecast from "./operateForecast";
import * as operationRecord from "./operationRecord";
import * as outMaster from "./outMaster";
import * as outMasterFacadeImpl from "./outMasterFacadeImpl";
import * as outPlanFacadeImpl from "./outPlanFacadeImpl";
import * as outPlanMaster from "./outPlanMaster";
import * as packageMaster from "./packageMaster";
import * as pda from "./pda";
import * as pickMaster from "./pickMaster";
import * as productSizeSection from "./productSizeSection";
import * as purchaseStockOccupyDetail from "./purchaseStockOccupyDetail";
import * as saleForecast from "./saleForecast";
import * as salesOwnerInfo from "./salesOwnerInfo";
import * as shopDepartmentMapping from "./shopDepartmentMapping";
import * as skuInfo from "./skuInfo";
import * as skuInfoDetail from "./skuInfoDetail";
import * as stagingAreaMaster from "./stagingAreaMaster";
import * as stockAgeFacadeImpl from "./stockAgeFacadeImpl";
import * as stockFreezeRecord from "./stockFreezeRecord";
import * as stockPool from "./stockPool";
import * as stockSnDetail from "./stockSnDetail";
import * as storageReportDamage from "./storageReportDamage";
import * as storageUnit from "./storageUnit";
import * as supplyDemandBalance from "./supplyDemandBalance";
import * as supplyDemandBalanceDetail from "./supplyDemandBalanceDetail";
import * as systemForecast from "./systemForecast";
import * as test from "./test";
import * as warehouse from "./warehouse";
import * as warehouseCost from "./warehouseCost";
import * as warehouseFacadeImpl from "./warehouseFacadeImpl";
import * as warehousePosition from "./warehousePosition";
import * as warehouseRules from "./warehouseRules";
import * as warehouseSku from "./warehouseSku";
import * as warehouseSkuFacadeImpl from "./warehouseSkuFacadeImpl";
import * as waybillMaster from "./waybillMaster";

export const wms = {
  allocationBatch,
  allocationBatchFacadeImpl,
  allocationBox,
  allocationContainer,
  allocationFacadeImpl,
  allocationMaster,
  allocationMasterFacadeImpl,
  allocationPlan,
  allolcationTrial,
  approvalFacade,
  approvalFacadeImpl,
  changeOrder,
  changeOrderDetail,
  common,
  defaultShopInfo,
  demandOrder,
  demandPlanFacadeImpl,
  finalTrialOrder,
  finalTrialOrderDetail,
  financeVoucherReport,
  firstTrialOrder,
  firstTrialOrderDetail,
  frozenCreateOrder,
  frozenState,
  inDetail,
  inDetailBox,
  inDetailRecord,
  inMaster,
  inMasterFacadeImpl,
  inPlateMaster,
  inoutStepRecord,
  inventoryMaster,
  lendMaster,
  logisticsCycleInfo,
  logisticsReturnRecord,
  logisticsReverseFacadeImpl,
  logisticsWaybillLabel,
  nsStorage,
  operateForecast,
  operationRecord,
  outMaster,
  outMasterFacadeImpl,
  outPlanFacadeImpl,
  outPlanMaster,
  packageMaster,
  pda,
  pickMaster,
  productSizeSection,
  purchaseStockOccupyDetail,
  saleForecast,
  salesOwnerInfo,
  shopDepartmentMapping,
  skuInfo,
  skuInfoDetail,
  stagingAreaMaster,
  stockAgeFacadeImpl,
  stockFreezeRecord,
  stockPool,
  stockSnDetail,
  storageReportDamage,
  storageUnit,
  supplyDemandBalance,
  supplyDemandBalanceDetail,
  systemForecast,
  test,
  warehouse,
  warehouseCost,
  warehouseFacadeImpl,
  warehousePosition,
  warehouseRules,
  warehouseSku,
  warehouseSkuFacadeImpl,
  waybillMaster,
};
